// Petit pub/sub module-level : porte la salle d'attente publique (voir
// components/WaitingRoom.jsx) hors de l'arbre React, pour que l'intercepteur
// axios de lib/api.js (qui ne vit pas dans un composant) puisse la déclencher
// dès qu'un appel API renvoie un 503 "queued" (voir storefront_queue_middleware
// côté backend).
let state = null; // null = pas en file ; {position, waiting, shopName} sinon
const listeners = new Set();

export function getQueueState() {
  return state;
}

export function setQueueState(next) {
  state = next;
  listeners.forEach((l) => l(state));
}

export function subscribeQueueState(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
